<template>
  <div class="payl8r-modal-backdrop"/>
  <div class="payl8r-modal-area">
    <div class="payl8r-modal">
      <div class="payl8r-header-area">
          <button type="button" class="payl8r-btn-close" @click="toggleModal">
            <CloseIcon class="close-icon"/>
          </button>
        <div>
          <div class="payl8r-header-contents">
            <div class="payl8r-logo">
              <svg
                  style="margin-top: 3px"
                  xmlns="http://www.w3.org/2000/svg" width="155.267" height="81.386"
                  viewBox="0 0 185.267 81.386">
                <path id="Path_106"
                      d="M72.041,9.491v32.57A24.48,24.48,0,0,1,47.633,66.469H-88.818a24.478,24.478,0,0,1-24.408-24.408V-14.917H47.633A24.481,24.481,0,0,1,72.041,9.491M-77.881,28.464h5.871c3.745,0,6.581-1.163,8.554-3.593a12.463,12.463,0,0,0,2.58-7.692,11.913,11.913,0,0,0-3.543-8.605c-2.075-1.924-4.758-2.783-8.6-2.783h-7.947a4.321,4.321,0,0,0-3.847,1.72c-.658.911-.81,1.518-.81,3.9V34.892c0,1.872.051,2.328.507,3.238a3.955,3.955,0,0,0,3.39,1.924,3.937,3.937,0,0,0,3.341-1.924,6.378,6.378,0,0,0,.506-3.238Zm0-6.732V12.521h4.3a4.437,4.437,0,0,1,4.758,4.657c0,2.731-2.024,4.554-5.162,4.554Zm42.769-4.4a3.707,3.707,0,0,0-3.695-3.8c-1.772,0-2.885.81-3.695,2.783-2.125-2.175-3.695-2.935-6.327-2.935a10.765,10.765,0,0,0-7.743,3.392,12.813,12.813,0,0,0-3.9,9.818q0,6.759,4.4,10.631a10.866,10.866,0,0,0,7.339,2.834c2.734,0,4.253-.759,6.125-3.088.759,1.973,1.973,2.935,3.745,2.935,2.227,0,3.745-1.772,3.745-4.4Zm-12.805,2.986c3.088,0,5.162,2.58,5.162,6.377s-2.075,6.429-5.112,6.429c-3.138,0-5.162-2.58-5.162-6.48,0-3.745,2.075-6.326,5.112-6.326m26.471,7.744L-25.8,17.024c-1.062-2.631-2.026-3.492-3.9-3.492a3.7,3.7,0,0,0-3.745,3.543,5.846,5.846,0,0,0,.759,2.785l7.339,17.361-2.935,6.831a6.123,6.123,0,0,0-.759,2.785,3.688,3.688,0,0,0,3.695,3.542c1.924,0,2.836-.81,3.948-3.39L-10.109,19.96a6.132,6.132,0,0,0,.759-2.832,3.754,3.754,0,0,0-3.8-3.595c-1.923,0-2.935.911-3.947,3.543ZM22,21.023c2.378-2.227,3.189-3.9,3.189-6.579,0-5.617-4.456-9.515-10.883-9.515-6.48,0-10.933,3.9-10.933,9.515,0,2.683.812,4.352,3.189,6.579-3.34,2.227-4.708,4.708-4.708,8.351,0,6.427,5.164,11.033,12.452,11.033,7.237,0,12.4-4.606,12.4-11.033,0-3.644-1.368-6.125-4.708-8.351M14.36,23.91A4.5,4.5,0,1,1,9.8,28.362,4.526,4.526,0,0,1,14.36,23.91m0-12.4a3.417,3.417,0,1,1-3.492,3.39,3.414,3.414,0,0,1,3.492-3.39M29.251,34.942c0,1.823.051,2.229.506,3.088a3.694,3.694,0,0,0,6.429,0c.455-.859.506-1.316.506-3.088V25.579c-.1-2.481,1.064-3.593,5.112-4.96,3.037-.911,3.8-1.62,3.8-3.39a3.8,3.8,0,0,0-3.8-3.848c-1.72,0-3.037.71-5.112,2.785A3.888,3.888,0,0,0,33,13.533c-2.278,0-3.745,1.671-3.745,4.253ZM-.137,7.359c0-1.823-.051-2.229-.506-3.088A3.7,3.7,0,0,0-3.832,2.449a3.664,3.664,0,0,0-3.24,1.874c-.455.808-.506,1.265-.506,3.037V34.942c0,1.823.051,2.229.506,3.088A3.664,3.664,0,0,0-3.832,39.9,3.641,3.641,0,0,0-.643,38.029c.455-.859.506-1.316.506-3.088Z"
                      transform="translate(113.226 14.917)" fill="#9E71FF"/>
              </svg>
            </div>
            <div class="payl8r-title-div inter-black"> Spread the cost. </div>
            <div class="payl8r-title-small-wording">Get what you need today and choose how you pay back, on your terms.</div>
          </div>
        </div>
      </div>
      <RepayMonth :installmentsInfo="installmentsInfo" :repExample="repExample" :deposit="deposit" :amount="price"/>
      <Info/>
      <Requirements/>
      <rep-example :installmentsInfo="installmentsInfo" :repExample="repExample" :deposit="deposit" :amount="price"/>
      <Footer :retailerName="retailerName" :broker-frn="brokerFrn" :firm-reference-number="firmReferenceNumber"/>
    </div>
  </div>
</template>
<script>
import RepayMonth from "./repayMonth";
import Info from "./infoComponent";
import Requirements from "./requirementsComponent";
import Footer from "./footerComponent";
import JQuery from 'jquery';
import CloseIcon from "@/components/CloseIcon.vue";
import RepExample from "./repExample.vue";

export default {
  components: {
    RepExample,
    CloseIcon,
    'RepayMonth': RepayMonth,
    'Info': Info,
    'Requirements': Requirements,
    'Footer': Footer,
  },
  props: {
    price: Number,
    username: String,
    isModalVisible: Boolean,
  },
  data() {
    return {
      installmentsInfo:{},
      repExample:{},
      deposit:null,
      retailerName: '',
      brokerFrn: null,
      firmReferenceNumber: null
    }
  },
  methods: {
    toggleModal() {
      this.$emit('toggleModal');
    },
    fetchData(total, username) {
      const vue = this;
      JQuery.ajax({
        url: 'https://payl8r.com/get-product-page-calculator?username=' + username + '&total=' + total + '&includeRepresentativeExample=true',
      }).done(function(response) {
        let data = JSON.parse(response)
        if (data.status === 200) {
          vue.installmentsInfo = data.data;
          vue.repExample = data.repExample
          vue.retailerName = data.retailerName
          vue.brokerFrn = data.brokerFrn
          vue.firmReferenceNumber = data.firmReferenceNumber
          // Obtain minimumDepositRate
          let termsObject = data.data;
          let firstTerm = Object.keys(termsObject)[0];
          let accessTermObject = data.data[firstTerm];
          vue.deposit = Number(total) * Number(accessTermObject.minimumDepositRate);
        }
      });
    },
  },watch:{
    price:function() {
      this.fetchedData = this.fetchData(this.price, this.username);
  },
},
  async beforeMount() {
    this.fetchedData = await this.fetchData(this.price, this.username);
  },

};
</script>
